<!--产品分类级联选择器，无回显-->
<template>
  <div>
    <el-cascader v-model="categoryTypeId"
                 :options="serviceTypeOption"
                 :props="{ checkStrictly: false,multiple:true, }"
                 :max-collapse-tags="1"
                 collapse-tags
                 collapse-tags-tooltip
                 @change="serviceTypeHandleChange"
                 :clearable="true"
                 :show-all-levels="false"
                 @clear="() => {
                   this.$emit('selectedCategoryType', []);
                   this.targetServer = [];
                 }"
    ></el-cascader>
  </div>
</template>

<script>

import api from "@/api/projectApi";

export default {
  name: 'categoryTypeCascaderDialog',
  mounted() {
    this.loadServiceTypeOptions();
  },

  data() {
    return {
      categoryTypeId: [],
      targetServer:[],
      serviceTypeOption: []
    }
  },

  methods: {
    serviceTypeHandleChange(data) {
      console.log("data",data)
      this.$emit('selectedCategoryType', data)
    },

    // 加载产品分类
    loadServiceTypeOptions() {
      this.$http.post(api.basItemCategory.getOptionUrl,
        {}
      ).then(res => {
        let list = []
        res.data.data.forEach(item => {
          if (item.children.length == 0) {
            delete item.children
          }
          list.push(item);
        })
        this.serviceTypeOption = list
      })
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-cascader__tags > span{
  display: flex !important;;
}
</style>
